export default __webpack_public_path__ + "static/media/m_openMenu.97000cae.svg";